import React from "react"
import { css } from "@emotion/react"
import { StaticImage } from "gatsby-plugin-image"

import AnimatedSection from "../animated-section"
import theme from "../../styles/theme"

const SolutationForBusinesses = ({ className }) => {
  return (
    <AnimatedSection
      className={className}
      leftElement={
        <div>
          <h2 className="dark text-sm-center">
            <em>Une solution vertueuse </em> pour les commerces
          </h2>
          <p className="margin-bottom-sm">
            Entrez dans le réseau WeRecy ! Les commerces partenaires sont au
            cœur de la collecte. Ils accueillent le particulier et son objet à
            recycler.
          </p>
        </div>
      }
      rightElement={
        <StaticImage
          imgStyle={{
            borderRadius: theme.shape.borderRadius[0],
            boxShadow: theme.elevation.level2,
          }}
          css={css`
            border-radius: ${theme.shape.borderRadius[0]};
            box-shadow: ${theme.elevation.level2};
          `}
          placeholder="blurred"
          width={450}
          src="../../images/index_solution_for_businesses_shop.jpg"
          alt=""
        />
      }
    />
  )
}

export default SolutationForBusinesses
